const Mission = () => {
  return (
    <section id="mission" className="bg-teal-50 py-20 md:py-28">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-bold text-teal-700">Our Vision for Sierra Leone</h2>
            <p className="mt-4 text-lg text-stone-600">Empowering communities in Sierra Leone through comprehensive oral health training, fostering a healthier future by building informed, engaged, and proactuve medical and dental  health leaders who contribute to the wellbeing of their communities.</p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-md border border-stone-200">
            <h3 className="text-2xl font-bold mb-3 text-teal-800">Our Mission</h3>
            <p className="text-stone-700 text-lg">To foster oral health awareness and promote healthier smiles through education, access to medical and dental care, and community engagement.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;